import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProgressiveImage from '../../../../../../components/global/ProgressiveImage';
import NativeActivityIndicator from '../../../../../../components/global/NativeActivityIndicator';

const propTypes = {
  className: PropTypes.string,
  cardSide: PropTypes.shape({
    id: PropTypes.string.isRequired,
    asset_image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    name: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const CardSidePreview = ({ className, cardSide, onClick, loading }) => {
  const classes = classNames({
    'card-side-preview': true,
    'is-loading': loading,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      onClick={event => {
        event.preventDefault();
        onClick(cardSide);
      }}
      className={classes}
    >
      <ProgressiveImage src={cardSide.asset_image?.url} alt="" />

      {loading && <NativeActivityIndicator size="sm" />}
    </a>
  );
};

CardSidePreview.propTypes = propTypes;

export default CardSidePreview;
